<p-dialog  
header="View Downloads"
class="action-item-modal b1 font-medium"
[modal]="true"
[(visible)]="attachmentModal"
[style]="{ width: '30rem' }"
[baseZIndex]="9999"
(onHide)="closeDownloadModal()"
>
<div class="wrapper p-l-20 p-r-20 p-t-25 p-b-25">
  <div
    class="dis-flex flex-sb-m flex-m m-b-15"
    *ngFor="let file of wpList?.files"
  >
    <div>
      <p class="b2 text-90 m-b-0">{{ file?.name }}</p>
    </div>
    <div>
      <button class="btn outline primary" (click)="downloadFile.emit(file)">
        Download
      </button>
    </div>
  </div>
</div>
</p-dialog>